import styled from "styled-components";

const AppWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export { AppWrapper };
